import "babel-polyfill"
import Es6Promise from 'es6-promise'
import Vue from 'vue'
import App from './App'
import router from './router'
import Http from '@/utils/http.js'
import Util from '@/utils/util.js'
import 'mint-ui/lib/style.css'
import './css/common.less'

require('es6-promise').polyfill();
Es6Promise.polyfill();
import {
    Navbar,
    TabItem,
    TabContainer,
    TabContainerItem,
    Field,
    Button,
    Picker,
    Popup,
    Cell,
    Header,
    Search,
    IndexList,
    IndexSection,
    DatetimePicker,
    Toast,
    Loadmore,
    InfiniteScroll,
    Switch,
    Checklist
} from 'mint-ui'
import {Indicator} from 'mint-ui';
import headerNav from '@/components/headerNav';
import page from '@/components/page';

Vue.component(Field.name, Field);
Vue.component(Button.name, Button);
Vue.component(Picker.name, Picker);
Vue.component(Popup.name, Popup);
Vue.component(Cell.name, Cell);
Vue.component(Header.name, Header);
Vue.component(Search.name, Search);
Vue.component(IndexList.name, IndexList);
Vue.component(IndexSection.name, IndexSection);
Vue.component(DatetimePicker.name, DatetimePicker);
Vue.component(Loadmore.name, Loadmore);
Vue.component(Switch.name, Switch);
Vue.component(Navbar.name, Navbar);
Vue.component(TabItem.name, TabItem);
Vue.component(TabContainer.name, TabContainer);
Vue.component(TabContainerItem.name, TabContainerItem);
Vue.component(Checklist.name, Checklist);
Vue.component("headerNav", headerNav);
Vue.component("page", page);
Vue.use(InfiniteScroll);
Vue.config.productionTip = false;
Vue.prototype.http = Http;
Vue.prototype.$util = Util;
Vue.prototype.$toast = Toast;
Vue.prototype.$indicator = Indicator;

const whiteList = ['Price', 'Login', 'Waybill','WaybillDesc'];
router.beforeEach((to, from, next) => {
    let companyNo = Util.get("companyNo");
    let token = Util.get(companyNo+"_token");
    if (companyNo && token) {
        next()
    } else if (whiteList.indexOf(to.name) !== -1) {
        next()
    } else if (to.query.token) {
        Http.sendNormal({command: "rWeixinClient/getLoginInfo", params: {token: to.query.token}}).then(res => {
            if (res.data.result_code === 0) {
                let companyNo = res.data.body[0].companyNo;
                let accountType = res.data.body[0].accountType;
                let userNo = res.data.body[0].userNo;
                let clientNo = res.data.body[0].clientNo;
                let role = res.data.body[0].role;
                let companyName = res.data.body[1].companyName;
                let userInfo = {
                    accountType,
                    userNo,
                    clientNo,
                    role,
                    companyName
                };
                Util.set("companyNo", companyNo);
                Util.set(companyNo+"_token", to.query.token);
                Util.set(companyNo+"_userInfo", userInfo);
                next({name: 'Main'});
            } else {
                next({name: 'Login', query: {companyNo: to.query.companyNo}})
            }
        })
    } else {
        next({name: 'Login', query: {companyNo: companyNo}});
    }
});
new Vue({
    el: '#app',
    router,
    components: {App},
    template: '<App/>'
});




// WEBPACK FOOTER //
// ./src/main.js